import { render, staticRenderFns } from "./cmpyReg.vue?vue&type=template&id=38f7086a&"
import script from "./cmpyReg.vue?vue&type=script&lang=js&"
export * from "./cmpyReg.vue?vue&type=script&lang=js&"
import style0 from "./cmpyReg.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports